export const sqaPageBanner = {
    mainHeading: "Software Quality",
    greenHeading: "Assurance Service",
    subHeadingGreen: "Trusted by Startups, SMBs, & Enterprises alike",
    sectionDescription: "Our software quality assurance services do not create release blocks but enhance the entire development cycle from the beginning.",
    buttonText: "Let's Get Started"
}

export const SaqDevelopmentServicesData = {
    sectionContent: {
        mainHeading: "Our Expansive Range of Software Quality Assurance Services.",
        sectionDescription: "Our web application services cover everything from custom cloud platforms & interactive portals to seamless front-end & robust back-end development. We deliver secure, scalable solutions designed to evolve with your business, including expert consulting & e-commerce development."
    },

    tabsData: [
        {
            id: "Tab1",
            label: "Web Portal QA & Testing",
            content:
                "A flawless web portal is crucial for a seamless user experience. Our comprehensive QA services focus on performance, security, & functionality to ensure your portal runs efficiently without issues.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "Backend QA & Security Testing",
            content:
                "We conduct rigorous backend testing to ensure your web portal’s infrastructure is secure, scalable, & free from vulnerabilities. Our security testing includes penetration testing, database integrity checks, API security validation, & server-side performance analysis to prevent cyber threats & ensure smooth functionality.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "Frontend Testing & UI/UX Validation",
            content:
                "A well-optimized frontend is key to user engagement & retention. Our team performs UI/UX validation, responsiveness testing, & cross-browser compatibility checks to ensure your portal delivers an intuitive, accessible, & visually appealing experience across all devices & platforms.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "Web Application QA Consulting",
            content:
                "We offer QA consulting to help businesses implement effective testing strategies, automation frameworks, & quality control processes. Our expertise ensures your web applications adhere to industry standards & best practices, reducing bugs, downtime, & performance bottlenecks.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "Custom Software Testing for Enterprises",
            content:
                "Enterprise applications require specialized testing to handle high traffic, complex workflows, & multiple integrations. Our tailored QA solutions include performance testing, scalability assessments, compliance verification, & real-time monitoring to ensure business continuity.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "Headless CMS & WordPress QA",
            content:
                "For content-driven businesses, we provide end-to-end testing for Headless CMS & WordPress platforms. Our process includes plugin compatibility checks, SEO validation, speed optimization, & security audits to enhance content delivery, search rankings, & overall performance.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
    ]
}

export const sqaTypesOfBuildData = {
    mainHeading: "Types of Software Testing We Offer",
    accordianData: [
        {
            id: "collapseOne",
            question: "Automated Testing",
            answer: {
                discription:
                    "Automated testing speeds up the QA process, running thousands of test cases instantly to catch bugs before launch. By leveraging automation, we ensure consistent quality, reducing manual effort while enhancing software performance, security, & reliability for seamless user experiences.",
                listTitle: "Our automated testing services are best for:",
                listContent: [
                    {
                        line: "Large-scale enterprise applications",
                    },
                    {
                        line: "Frequent software updates & releases",
                    },
                    {
                        line: "Performance optimization & stress testing",
                    },
                    {
                        line: "Identifying security vulnerabilities",
                    },
                    {
                        line: "Enhancing accuracy with minimal manual effort",
                    },
                ],
            },
        },
        {
            id: "collapseTwo",
            question: "Manual Testing",
            answer: {
                discription:
                    "Sometimes, only a human eye can spot subtle issues! Our manual testing experts simulate real-world scenarios, ensuring software feels intuitive, responsive, & user-friendly. We dig deep into your system, making sure no bug slips through, delivering a polished, flawless user experience.",
                listTitle: "Our manual testing services are best for:",
                listContent: [
                    {
                        line: "Usability & exploratory testing",
                    },
                    {
                        line: "Complex workflows & user journeys",
                    },
                    {
                        line: "Apps requiring human judgment",
                    },
                    {
                        line: "Ensuring intuitive UI/UX design",
                    },
                    {
                        line: "Identifying edge-case bugs",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "Performance Testing",
            answer: {
                discription:
                    "A slow app drives users away! We test your software under real-world pressure—simulating high traffic, stress loads, & extreme conditions to ensure smooth, lag-free performance. Our testing guarantees your software solutions run efficiently, even during peak demand.",
                listTitle: "Our performance testing services are best for:",
                listContent: [
                    {
                        line: "High-traffic web & mobile applications",
                    },
                    {
                        line: "Load balancing & scalability testing",
                    },
                    {
                        line: "Ensuring quick response times",
                    },
                    {
                        line: "Apps handling real-time data processing",
                    },
                    {
                        line: "Identifying performance bottlenecks",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "Security Testing",
            answer: {
                discription:
                    "Cyber threats are real—and we ensure your software is fortified against them. Our security testing detects & fixes vulnerabilities before hackers do, safeguarding sensitive data, user privacy, & business integrity. From penetration testing to compliance checks, we've got your security covered.",
                listTitle: "Our security testing services are best for:",
                listContent: [
                    {
                        line: "Protecting sensitive customer data",
                    },
                    {
                        line: "E-commerce & financial transactions",
                    },
                    {
                        line: "Compliance with security standards (ISO, GDPR)",
                    },
                    {
                        line: "Vulnerability assessments & ethical hacking",
                    },
                    {
                        line: "Preventing unauthorized access & threats",
                    },
                ],
            },
        },
        {
            id: "fifth",
            question: "Compatibility Testing",
            answer: {
                discription:
                    "Your software should work flawlessly everywhere! Whether it’s iOS, android, Windows, Mac, or wearables, our compatibility testing ensures a seamless experience across all platforms, browsers, & devices. No matter where your users are, your software stays smooth & accessible.",
                listTitle: "Our compatibility testing services are best for:",
                listContent: [
                    {
                        line: "Multi-platform mobile & desktop applications",
                    },
                    {
                        line: "Ensuring browser & OS compatibility",
                    },
                    {
                        line: "Responsive web applications",
                    },
                    {
                        line: "Wearables & IoT devices",
                    },
                    {
                        line: "Cross-device consistency",
                    },
                ],
            },
        },
        {
            id: "sixth",
            question: "Regression Testing",
            answer: {
                discription:
                    "Every update should improve, not break your app! Our regression testing ensures that when new features roll out, everything still works perfectly. We retest core functions, ensuring previous updates & integrations stay intact & reliable, preventing unexpected glitches.",
                listTitle: "Our regression testing services are best for:",
                listContent: [
                    {
                        line: "Continuous software updates & enhancements",
                    },
                    {
                        line: "Testing new features without breaking old ones",
                    },
                    {
                        line: "Complex systems with multiple integrations",
                    },
                    {
                        line: "Fast-paced agile development cycles",
                    },
                    {
                        line: "Preventing post-release issues",
                    },
                ],
            },
        },
    ]
}

export const sqaWhoWeServeData = {
    sectionContent: {
        mainHeading: "Who We Serve",
        sectionDescription: "We help businesses of all sizes achieve flawless software performance through comprehensive software quality assurance services. Whether you're a startup launching a new product, a software company scaling your platform, or an enterprise requiring large-scale testing solutions, our QA experts ensure bug-free, high-performance, & secure software."
    },
    cardsData: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "Startups",
            description:
                "Testing from the ground up to ensure your MVP or first release is smooth, functional, & user-friendly. Our QA services help startups identify potential issues before launch, ensuring a seamless experience for early adopters.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "Software product companies",
            description:
                "Software companies require ongoing testing as their platforms grow. We offer continuous QA services to identify bugs, compatibility issues, & security vulnerabilities, ensuring that your software solutions perform optimally across all versions & updates.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "Enterprises from 30+ industries",
            description:
                "Large-scale businesses require robust software quality assurance to maintain compliance, security, & performance across complex systems. We ensure enterprise software remains secure, scalable, & efficient while minimizing downtime & risks.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const sqaWhyChooseBitsclanData = {
    sectionContent: {
        mainHeading: "Why Choose Bitsclan as Your QA Services Company?",
        sectionDescription: "At Bitsclan, we provide end-to-end software quality assurance, ensuring your applications are bug-free, scalable, & secure. Our QA experts focus on seamless functionality, automation, & performance testing so your software meets industry standards & user expectations. From automated testing to manual evaluations, we tailor QA solutions to keep your software at its best."
    },
    tabsData: [
        {
            id: "Tab1",
            label: "Quality Because It Matters",
            content:
                "At Bitsclan, quality is not just a goal—it’s a standard embedded into every stage of the development lifecycle. We adopt a comprehensive quality assurance strategy that includes functional, regression, usability, performance, & compatibility testing.",
            content2:
                "Our dedicated QA teams use industry-leading tools & best practices to ensure every product we deliver meets the highest standards of performance, security, & user experience. By detecting & resolving issues early, we help you avoid costly setbacks & deliver robust, bug-free solutions that build trust with your users.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "The best-of-the-breed talent",
            content:
                "Our QA experts are carefully selected from among the industry’s top professionals, bringing years of specialized experience & an unwavering commitment to excellence. Each member of our team is skilled in a wide range of testing methodologies—from manual exploratory testing to fully automated test suites.",
            content2:
                "With a strong foundation in agile workflows & CI/CD pipelines, our QA specialists work closely with your development team to ensure your applications are efficient, scalable, & aligned with your business objectives. We don't just test software—we improve it.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "Time zone Alignment",
            content:
                "Global clients demand seamless collaboration, & that’s exactly what we deliver. Our team is strategically distributed & fully capable of aligning with your preferred working hours, ensuring timely updates, fast feedback loops, & consistent progress tracking.",
            content2:
                "Whether you're in North America, Europe, the Middle East, or Asia-Pacific, we adapt to your schedule & guarantee transparent, real-time communication. With Bitsclan, time zones are no longer a barrier—they’re a bridge to productivity & collaboration.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "Automation for Faster Testing",
            content:
                "In today’s fast-paced development environment, speed & accuracy are non-negotiable. Our automation testing services are designed to significantly reduce manual effort & increase test coverage across your application.",
            content2:
                "We leverage advanced tools such as Selenium, Appium, & Cypress to build reliable & reusable test scripts. From regression testing to performance validation, our automation approach ensures you can deploy confidently & scale quickly.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "Security Testing for Data Protection",
            content:
                "Cybersecurity is a top priority in the digital age, & our QA strategy reflects that. We provide robust security testing services that uncover vulnerabilities & prevent unauthorized access to your applications.",
            content2:
                "Our process includes penetration testing, threat modeling, & compliance checks that help protect sensitive data & ensure regulatory compliance. By proactively addressing potential risks, we safeguard your business & user trust.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
    ]
}

export const sqaHighvaluesData = {
    mainHeading: "High-Value Features for High-Performance QA Services",
    sectionDescription: "Our QA services ensure your software meets top industry standards with seamless functionality, security, & efficiency. We focus on comprehensive testing, automation, & real-time monitoring to deliver error-free, scalable, & high-performance applications.",
    buttonText: "Consult Project Scope",
    cardsData: [
        {
            image: "qa-icon-1.svg",
            text: "Automated Testing",
        },
        {
            image: "qa-icon-2.svg",
            text: "Manual Testing",
        },
        {
            image: "qa-icon-3.svg",
            text: "Performance Testing",
        },
        {
            image: "qa-icon-4.svg",
            text: "Security Testing",
        },
        {
            image: "qa-icon-5.svg",
            text: "Functional Testing",
        },
        {
            image: "qa-icon-6.svg",
            text: "Regression Testing",
        },
        {
            image: "qa-icon-7.svg",
            text: "Usability Testing",
        },
        {
            image: "qa-icon-8.svg",
            text: "Compatibility Testing",
        },
        {
            image: "qa-icon-9.svg",
            text: "Load & Stress Testing",
        },
        {
            image: "qa-icon-10.svg",
            text: "Bug Tracking & Reporting",
        },
    ]
}

export const sqaRoadMapData = {
    heading: "Our Proven Roadmap to Deliver Flawless Software Quality Assurance",
    description:
        "Ensuring your software runs smoothly is our top priority. We follow a structured QA roadmap designed to identify, prevent, & resolve defects efficiently. From initial planning to continuous optimization, we make sure your software meets high-quality standards, is bug-free, & performs flawlessly across all platforms. Here's how we ensure excellence:",
    roadMapsteps: [
        "We dive deep into your software’s architecture, define testing objectives, & map out a QA strategy that ensures seamless functionality.",
        "Our QA experts rigorously test for functionality, performance, security, & compatibility, ensuring your software meets industry quality standards.",
        "We provide ongoing testing, real-time issue resolution, & quality improvements to maintain software stability, security, & reliability.",
        "We design a customized testing framework, selecting the right automated & manual testing approaches to ensure efficiency & high performance.",
    ],
    roadMapHeading: [
        "",
        "Implementation & Execution",
        "Monitoring & Optimization",
        "Test Strategy & Proof of Concept",
    ],
};

export const sqaCoverTheStack = {
    mainHeading: "Enhance Your QA with a Powerful Tech Stack",
    sectionDescription: "At Bitsclan, we leverage industry-leading technologies to ensure top-tier software quality assurance. Our advanced tech stack optimizes testing processes, enhances automation, & ensures seamless performance, security, & scalability throughout the software development lifecycle.",
    defaultTabOpen: "Test Automation Tools",

    tabs: [
        "Test Automation Tools",
        "Test or Defect Management Tools",
        "Documentation tools",
        "Testing Tools",
    ],

    tabItems: [
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/selenium.svg", name: "Selenium" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/playwright.svg", name: "Playwright" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/test-io.svg", name: "Test.io" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/cucumber.svg", name: "Cucumber" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/browserstack.svg", name: "Browserstack" },
        { tab: "Test Automation Tools", icon: "/images/tech-stack-icons/cicd.svg", name: "Ci/Cd" },

        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/jira.svg", name: "Jira" },
        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/trello.svg", name: "Trello" },
        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/asana.svg", name: "Asana" },
        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/bugzilla.svg", name: "Bugzilla" },
        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/open-project.svg", name: "OpenProject" },
        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/testrail.svg", name: "Testrail" },
        { tab: "Test or Defect Management Tools", icon: "/images/tech-stack-icons/click-up.svg", name: "Clickup" },

        { tab: "Documentation tools", icon: "/images/tech-stack-icons/notion.svg", name: "Notion" },
        { tab: "Documentation tools", icon: "/images/tech-stack-icons/jira-confluence.svg", name: "Jira-Confluence " },

        { tab: "Testing Tools", icon: "/images/tech-stack-icons/excel.svg", name: "Excel" },
        { tab: "Testing Tools", icon: "/images/tech-stack-icons/word.svg", name: "Word" },
        { tab: "Testing Tools", icon: "/images/tech-stack-icons/apache.svg", name: "Apache Jmeter" },
        { tab: "Testing Tools", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
        { tab: "Testing Tools", icon: "/images/tech-stack-icons/swagger.svg", name: "Swagger" },
    ]
}

export const sqaIndustriesHeading = {
    mainHeading: "Industries we serve in Software Quality Assurance"
}

export const sqaFaqData = {
    mainHeading: "FAQs",
    sectionDescription: "Get quick answers to your questions about our mobile app development process & services.",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "What is software quality assurance (QA) & why is it important?",
            answer:
                "Software quality assurance (QA) ensures that your application functions properly, meets user expectations, & complies with industry standards. By using both automated & manual testing, QA services identify potential issues early in the development process, saving time & cost while ensuring reliable, high-quality products.",
        },
        {
            id: "collapseTwo",
            question: "How do automated testing & manual testing differ?",
            answer:
                "Automated testing uses scripts & tools to perform tests quickly & repeatedly, making it perfect for regression tests & large-scale systems. On the other hand, manual testing involves human testers who explore applications to find unexpected behavior & usability issues that automation may miss. Both are crucial to delivering top-quality software.",
        },
        {
            id: "collapseThree",
            question: "What types of QA services do you provide?",
            answer:
                "We offer a full range of software quality assurance services, including automated testing, manual testing, performance testing, security testing, & QA consulting. Whether you're launching a mobile app or a complex web platform, we ensure everything runs smoothly & securely for your users.",
        },
        {
            id: "fourth",
            question: "How can QA consulting help my business?",
            answer:
                "Our QA consulting services guide your team through the best practices in software testing. We analyze your current processes, recommend improvements, & help implement testing strategies that fit your project's specific needs. Our goal is to ensure that your software meets all functional, security, & user experience standards.",
        },
        {
            id: "fifth",
            question: "Is your QA service compatible with all types of software?",
            answer:
                "Yes, we provide QA services for all types of software—whether it's mobile apps, web applications, or enterprise systems. Our team has experience across various industries, ensuring that your software solution is tested thoroughly, from functionality to user experience & security.",
        },
        {
            id: "sixth",
            question: "Why should I invest in QA services for my software project?",
            answer:
                "Investing in QA services helps you catch potential issues before they reach your customers, ensuring smooth user experiences & reducing the risk of costly errors. With the help of automated & manual testing, we help you create a product that’s high-performing, secure, & user-friendly.",
        },
        {
            id: "seventh",
            question: "How can I get started with your QA services?",
            answer:
                "Getting started is easy! Just reach out to us, & our experts will assess your project & recommend the best QA strategy. We will walk you through the testing phases & help ensure that your software meets all necessary standards for a successful launch. Let’s work together to deliver quality solutions!",
        },
    ]
}

export var mainBannerImg = {
    backgroundImage: `url(/images/what-we-do/software-quality-assurance-service.avif)`
}

export const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
        "@type": "Question",
        "name": "What is software quality assurance (QA) & why is it important?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Software quality assurance (QA) ensures that your application functions properly, meets user expectations, & complies with industry standards. By using both automated & manual testing, QA services identify potential issues early in the development process, saving time & cost while ensuring reliable, high-quality products."
        }
    }, {
        "@type": "Question",
        "name": "How do automated testing & manual testing differ?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Automated testing uses scripts & tools to perform tests quickly & repeatedly, making it perfect for regression tests & large-scale systems. On the other hand, manual testing involves human testers who explore applications to find unexpected behavior & usability issues that automation may miss. Both are crucial to delivering top-quality software."
        }
    }, {
        "@type": "Question",
        "name": "How can QA consulting help my business?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our QA consulting services guide your team through the best practices in software testing. We analyze your current processes, recommend improvements, & help implement testing strategies that fit your project's specific needs. Our goal is to ensure that your software meets all functional, security, & user experience standards."
        }
    }, {
        "@type": "Question",
        "name": "What types of QA services do you provide?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer a full range of software quality assurance services, including automated testing, manual testing, performance testing, security testing, & QA consulting. Whether you're launching a mobile app or a complex web platform, we ensure everything runs smoothly & securely for your users."
        }
    }, {
        "@type": "Question",
        "name": "Is your QA service compatible with all types of software?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we provide QA services for all types of software—whether it's mobile apps, web applications, or enterprise systems. Our team has experience across various industries, ensuring that your software solution is tested thoroughly, from functionality to user experience & security."
        }
    }, {
        "@type": "Question",
        "name": "Why should I invest in QA services for my software project?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "nvesting in QA services helps you catch potential issues before they reach your customers, ensuring smooth user experiences & reducing the risk of costly errors. With the help of automated & manual testing, we help you create a product that’s high-performing, secure, & user-friendly."
        }
    }, {
        "@type": "Question",
        "name": "How can I get started with your QA services?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Getting started is easy! Just reach out to us, & our experts will assess your project & recommend the best QA strategy. We will walk you through the testing phases & help ensure that your software meets all necessary standards for a successful launch. Let’s work together to deliver quality solutions!"
        }
    }]
}